import { useCan } from '../useCan';
import { useCosts } from '../margin/useCosts';
import { MarginLines } from '../margin/MarginLines';
import { orderContribution, type MarginLine } from '../../core/rules/margin';
import { saleMethods } from '../../core/rules/kassa';
import type { Sale } from '../../core/types/kassa';

/**
 * Kassabon › Wat er overblijft (alleen `finance.margin`). Cadeaubonnen tellen niet (dat is een
 * schuld, geen omzet); behandelingen en kuren hebben geen inkoop. Het productverbruik tijdens een
 * behandeling telt nog niet mee: dat is de kostprijs van een behandeling, buiten dit overzicht.
 */
export function SaleMarginLines({
  sale: s
}: {
  sale: Sale;
}) {
  const {
    canAll
  } = useCan();
  const allowed = canAll('finance.margin');
  const {
    data
  } = useCosts(allowed);
  if (!allowed || s.status === 'gecorrigeerd') return null;
  const lines: MarginLine[] = s.lines.filter(l => l.kind !== 'giftcard' && l.totalCents > 0).map(l => ({
    name: l.name,
    qty: l.kind === 'product' ? l.qty : 1,
    grossCents: l.totalCents,
    vatRate: l.vatRate,
    costCents: l.kind === 'product' ? data?.itemCosts[l.productId] ?? null : 0
  }));
  if (lines.length === 0) return null;
  return <div className="border-t border-line pt-3" data-id="element-2587" data-mp="2efvxfrdi43g0">
      <p className="mb-2 text-ink" data-id="element-2588" data-mp="2ehqn1izpwjqf">
        Wat er overblijft <span className="text-muted" data-id="element-2589" data-mp="29nur0m30l6xw">· geschat · vóór vaste lasten</span>
      </p>
      {!data ? <p className="text-muted" data-id="element-2590" data-mp="2ocqyoi15shxz">Laden…</p> : <MarginLines breakdown={orderContribution({
      kind: 'salon',
      lines,
      paymentMethod: 'pin',
      paidCents: saleMethods(s).pin,
      shipping: null
    }, data.costs)} className="max-w-sm" data-id="element-2591" data-mp="2jepf7vztmglz" />}
      {s.lines.some(l => l.kind === 'treatment') && <p className="mt-2 text-[12px] text-muted" data-id="element-2592" data-mp="2tdelericucme">Productverbruik tijdens de behandeling telt hier nog niet mee.</p>}
    </div>;
}